import React, { FC } from "react";
import { Wrapper } from "./style";


interface IProps {
  alterNames: string[]
}
export const AlterNames: FC<IProps> = ({ alterNames }) => {
  return (
    <Wrapper>
      <label>Другие названия дисциплин</label>
      {alterNames.map((i, idx) => (
        <div key={idx}>{i}</div>
      ))}
    </Wrapper>
  );
};
